import { defineRouter } from "#q-app/wrappers";
import {
  createRouter,
  createMemoryHistory,
  createWebHistory,
  createWebHashHistory,
} from "vue-router";

// import routes from './routes'

// File system based routing using:
// https://github.com/hannoeru/vite-plugin-pages
// https://github.com/JohnCampionJr/vite-plugin-vue-layouts
import routes from "~pages";
import { setupLayouts } from "virtual:generated-layouts";

/*
 * If not building with SSR mode, you can
 * directly export the Router instantiation;
 *
 * The function below can be async too; either use
 * async/await or return a Promise which resolves
 * with the Router instance.
 */

export default defineRouter(function (/* { store, ssrContext } */) {
  const createHistory = process.env.SERVER
    ? createMemoryHistory
    : process.env.VUE_ROUTER_MODE === "history"
      ? createWebHistory
      : createWebHashHistory;

  const Router = createRouter({
    scrollBehavior: () => ({ left: 0, top: 0 }),
    routes: setupLayouts(routes),

    // Leave this as is and make changes in quasar.conf.js instead!
    // quasar.conf.js -> build -> vueRouterMode
    // quasar.conf.js -> build -> publicPath
    history: createHistory(process.env.VUE_ROUTER_BASE),
  });

  Router.afterEach(() => {
    if (process.env.CLIENT && process.env.PROD && process.env.MODE === "pwa") {
      globalThis.navigator.serviceWorker.ready
        .then((registration) => {
          registration.update();
        })
        .catch((error) => [
          console.error("Service worker registration failed:", error),
        ]);
    }
  });

  return Router;
});
